export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  WHATSAPP_EMBEDDED_SIGNUP_FLOW: 'whatsapp_embedded_signup_inbox_creation',
  WHATSAPP_MANUAL_TRANSFER: 'whatsapp_manual_transfer',
  WHATSAPP_RECONFIGURE: 'whatsapp_reconfigure',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  DATA_IMPORT: 'data_import',
  API_AND_WEBHOOKS: 'api_and_webhooks',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  PIPELINE_BOARD: 'pipeline_board',
  FOLLOW_UPS: 'follow_ups',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_TASKS: 'captain_tasks',
  CAPTAIN_DOCUMENT_AUTO_SYNC: 'captain_document_auto_sync',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  FLOW_BUILDER: 'flow_builder',
  LEAD_SCORE: 'lead_score',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  APPOINTMENTS_MODULE: 'appointments_module',
  APPOINTMENTS_CAPTAIN_BOOKING: 'appointments_captain_booking',
  APPOINTMENTS_GOOGLE_SYNC: 'appointments_google_sync',
  APPOINTMENTS_PUBLIC_WIDGET: 'appointments_public_widget',
  // NOOVI: Broadcasts (Disparador em Massa) (f6137324d8)
  BROADCASTS: 'disparador',
  // NOOVI: Hub WhatsApp (NooviConnect) — toggle por conta no super admin
  WHATSAPP_HUB: 'whatsapp_hub',
  // NooviChat: Chat Interno
  INTERNAL_CHAT: 'chat_interno',
  // NooviChat: Pipeline Sequences (cadências de atividades por card)
  PIPELINE_SEQUENCES: 'pipeline_sequences',
  // NooviChat: Oportunidades (Fase 59) — cross feature sobre o Pipeline Pro.
  // Desligada, o funil segue ganhando e perdendo negócio com o valor no card;
  // ligada, o ganho vira venda de um produto do catálogo. Requer PIPELINE_BOARD
  // (a dependência é imposta no servidor, config/features.yml `requires:`).
  PIPELINE_OPPORTUNITIES: 'pipeline_opportunities',
  // NOOVI: Análise Comercial — feature nativa NooviChat (fase-31)
  COMMERCIAL_ANALYSIS: 'commercial_analysis',
  // Upstream v4.14.1
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  UNREAD_COUNT_FOR_FILTERS: 'unread_count_for_filters',
};

export const CONFIGURATION_NOTICE_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.LEAD_SCORE,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
];
